export const JITSI_CONFIG_OVERWRITE = {
  startWithVideoMuted: true,
  startWithAudioMuted: false,
  startAudioMuted: 4,
  enableNoAudioDetection: true,
  enableNoisyMicDetection: true,
  enableInsecureRoomNameWarning: true,
  disableSimulcast: false,
  disableLocalVideoFlip: true,
  doNotStoreRoom: true,
  disableDeepLinking: true,
};

export const JITSI_INTERFACE_CONFIG_OVERWRITE = {
  'TOOLBAR_BUTTONS': [
    'microphone', 'camera', 'closedcaptions', 'desktop', 'fullscreen',
    'fodeviceselection', 'hangup', 'profile', 'recording', 'chat',
       /* 'livestreaming'*/, 'etherpad', 'sharedvideo', 'settings', 'raisehand',
    'videoquality', 'filmstrip', 'invite', 'feedback', /*'stats', 'shortcuts',*/
    'tileview', 'videobackgroundblur', 'download', 'help', 'security',
  ],
  INVITATION_POWERED_BY: true,
  SHOW_CHROME_EXTENSION_BANNER: false,
  filmStripOnly: false,
  DEFAULT_REMOTE_DISPLAY_NAME: 'IHX User',
  // DEFAULT_LOGO_URL: window.location.origin + '/ihx-logo.png',
  // DEFAULT_WELCOME_PAGE_LOGO_URL: window.location.origin + '/ihx-logo.png',
  SHOW_JITSI_WATERMARK: false,
};
